import CitySEOHead from "@/components/feature/CitySEOHead";
import PasadenaHeroSection from "./components/HeroSection";
import PasadenaStickyNav from "./components/StickyNav";
import PasadenaProcessingTimeSection from "./components/ProcessingTimeSection";
import PasadenaServicesSection from "./components/ServicesSection";
import PasadenaLocalAreaSection from "./components/LocalAreaSection";
import PasadenaTravelTimingSection from "./components/TravelTimingSection";
import PasadenaDestinationsSection from "./components/DestinationsSection";
import PasadenaTestimonialsSection from "./components/TestimonialsSection";
import PasadenaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PasadenaComparisonSection from "./components/ComparisonSection";
import PasadenaMistakesSection from "./components/MistakesSection";
import PasadenaHowItWorksSection from "./components/HowItWorksSection";
import PasadenaFAQSection, { faqs } from "./components/FAQSection";
import PasadenaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PasadenaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function PasadenaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Pasadena"
        state="California"
        stateAbbr="CA"
        route="/pasadena"
        title="Emergency Passport Pasadena, CA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Pasadena, CA — as fast as 24 hours. Serving Caltech, JPL, Arcadia, and all of the San Gabriel Valley. A+ BBB rated, registered State Dept. courier. Best price guarantee."
        geoPlacename="Pasadena, California"
        geoPosition="34.1478;-118.1445"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="California"
        statePageRoute="/states/california"
      />
      <PasadenaHeroSection />
      <PasadenaStickyNav />
      <PasadenaProcessingTimeSection />
      <PasadenaLocalAreaSection />
      <PasadenaServicesSection />
      <PasadenaTravelTimingSection />
      <PasadenaDestinationsSection />
      <PasadenaTestimonialsSection />
      <PasadenaAcceptanceFacilitiesSection />
      <PasadenaComparisonSection />
      <PasadenaMistakesSection />
      <PasadenaHowItWorksSection />
      <PasadenaFAQSection />
      <PasadenaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/pasadena" state="CA" />
      <PasadenaFinalCTA />
    </div>
  );
}